import { NitroText } from 'nitro-components';
import styled from 'styled-components';

import React, { PropTypes, Component } from 'react';

import { DriverAvatar } from '../../../../components/driver';
import { media } from '../../../../utils/style-utils';
import ButtonIcognito from '../../../../components/common/ButtonIcognito';

const Card = styled(ButtonIcognito)`
  text-align: center;
`;

const CardIcon = styled.div`
  display: flex;
  justify-content: center;
  align-contents: center;
`;

const CardDescription = styled.div`
  margin: 30px auto;
`;

const CardDescriptionLabel = styled.span`
  display: inline-block;
  margin-left: 0.5em;
`;

class CardMetricDriver extends Component {
  onClick = (id, countryCode) => {
    //NOTE: to be updated to url to driver dashboard once its ready - Mythreyi - DONE
    //this.props.onPanelClick(this.props.driverId);

    const dashRoute = `/v1/dashboard/driver/${countryCode.toLowerCase()}/${id}`;

    this.context.router.push({
      pathname: dashRoute,
      state: { id, dashboardType: 'driver' },
    });
  };

  render() {
    const { driverId, driverName, Description, countryCode } = this.props;
    return (
      <Card onClick={() => this.onClick(driverId, countryCode)}>
        <CardIcon>
          <DriverAvatar
            size={72}
            varaint="secondary"
            opacity={0.8}
            profileIconVariant="secondary"
            profileIconSize={40}
            right={0}
          />
        </CardIcon>
        <CardDescription>
          <CardDescriptionLabel>
            <NitroText bold size={18} variant="secondary">
              {driverName}
            </NitroText>
          </CardDescriptionLabel>
        </CardDescription>
        <NitroText bold size={4} variant="base3">
          {Description}
        </NitroText>
      </Card>
    );
  }
}

CardMetricDriver.contextTypes = {
  router: PropTypes.object,
};

CardMetricDriver.propTypes = {
  driverId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  driverName: PropTypes.string,
  Description: PropTypes.string,
};

export default CardMetricDriver;



// WEBPACK FOOTER //
// ./src/features/dashboard/components/ProfileTabs/CardMetricDriver.js